import React from 'react';
import {changeToSlug} from '@helper/string.helper';
import LoadingDetailLink from './LoadingDetailLink';

export default function LinkSpecialistDoctorDetail({doctor = {}, children}) {
    const nameSlug = changeToSlug(doctor.full_name);
    const id = doctor.uuid || doctor.user_id || doctor.id;
    const slug = nameSlug && id ? `${nameSlug}-u${id}` : '';

    return <LoadingDetailLink href={slug ? `/${slug}` : ''}>{children}</LoadingDetailLink>;
}
